"use client";

import { mergeProps } from "@react-aria/utils";
import type { HTMLAttributes } from "react";

import { cn } from "../../utils";
import { useTextFieldRootContext } from "./context";

export type TextFieldErrorMessageProps = HTMLAttributes<HTMLSpanElement> & {
  variant?: "error" | "warning";
};

const ErrorMessage = ({ variant = "error", ...props }: TextFieldErrorMessageProps) => {
  const { textField } = useTextFieldRootContext();
  const mergedProps = mergeProps(props, textField?.errorMessageProps);

  const displayError = mergedProps.children || (textField?.validationErrors.length && textField?.validationErrors[0]);

  if (!textField?.isInvalid || !displayError) {
    return null;
  }

  return (
    <span
      {...mergedProps}
      className={cn(
        "text-sm",
        variant === "error" ? "text-error-50" : "text-warning-60",
        mergedProps.className,
        props.className
      )}
    >
      {displayError}
    </span>
  );
};

export default ErrorMessage;
